import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { User } from '@common/core/models';
import { IBitfApiRequest } from '../../api/bitf-api.interface';
import { BitfApiService } from '../../api/bitf-api.service';
import { EBitfStrapiProvider } from './bitf-strapi-provider-auth.enum';
import { IBitStrapiProviderLogin } from './bitf-strapi-provider-auth.interface';

@Injectable({
  providedIn: 'root',
})
export class BitfStrapiProviderService extends BitfApiService {
  constructor(public injector: Injector) {
    super('auth', injector);
  }

  getToken(accessToken: string, provider: EBitfStrapiProvider) {
    return this.request<IBitStrapiProviderLogin>({
      method: 'GET',
      path: `/${provider}/callback`,
      queryParams: { access_token: accessToken },
    } as IBitfApiRequest).pipe(
      map(response => ({
        ...response,
        content: {
          ...response.content,
          ...(response.content?.user && { user: new User(response.content?.user) }),
        },
      }))
    );
  }
}
